export default {
  listContas: [],
  conta: {
    id: '',
    nome: '',
    descricao: '',
    tipoConta: null,
    banco: null,
    agencia: '',
    conta: '',
    digitoVerificador: '',
    dataSaldoInicial: null,
    valorSaldoInicial: 0.0,
    moeda: 'BRL',
    principal: false,
    permiteSaldoNegativo: false,
    ativo: true,
  },
}
